/*
 *  -----------------------------------------------------------------------
 *    <copyright file="icon-button.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import IconButton from '@mui/material/IconButton';
import React from 'react';

export default function (props: any) {
    return <IconButton size="large" {...props} />;
}
